import { EDocMetadataProps } from '@/components/EDocMetadata';
import { FC, memo } from 'react';
import { InnerDetails } from './InnerDetails';
import { MenuContent } from './MenuContent';

type PopoverContentProps = {
  onClose: VoidFunction;
  showMetadata: boolean;
  onCloseMetadata: VoidFunction;
  onOpenFileInfo: VoidFunction;
  onDownload: VoidFunction;
  eDocProps?: EDocMetadataProps;
};

export const PopoverContent: FC<PopoverContentProps> = memo(
  ({
    onClose,
    showMetadata,
    onCloseMetadata,
    onOpenFileInfo,
    onDownload,
    eDocProps,
  }) => {
    const handleClose = () => {
      onCloseMetadata();
      onClose();
    };

    if (showMetadata && eDocProps) {
      return <InnerDetails onClose={handleClose} {...eDocProps} />;
    }

    return (
      <MenuContent
        onClose={handleClose}
        onOpenFileInfo={onOpenFileInfo}
        onDownload={onDownload}
        eDocMeta={eDocProps}
      />
    );
  }
);

PopoverContent.displayName = 'PopoverContent';
